import { render } from "./UploadInstructions.vue?vue&type=template&id=ec5cc408&scoped=true&ts=true"
import script from "./UploadInstructions.vue?vue&type=script&lang=ts"
export * from "./UploadInstructions.vue?vue&type=script&lang=ts"

import "./UploadInstructions.vue?vue&type=style&index=0&id=ec5cc408&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec5cc408"]])

export default __exports__